import React from 'react';
import {usePersistNodesOnChangeViewKind} from './use-persist-nodes-on-change-view-kind';

export function useGraphSelectionProps() {
    const [hoveredNodes, setHoveredNodes] = React.useState<number[]>([]);
    const [hoveredEdges, setHoveredEdges] = React.useState<number[]>([]);
    const [selectedNodes, setSelectedNodes] = React.useState<number[]>([]);

    // this hack is used to prevent onNodesLoaded function to run when undoing an
    // action that had selectionChanged effect, in this case we don't need to run
    // a function to determine new selected nodes, bc they will be set from undoing the
    // changeSelection effect, and running this func may cause errors
    const [isRevertingSelChangeEffect, setIsRevertingSelChangeEffect] = React.useState(false);

    const onNodesSelected = React.useCallback(
        (inputNodeIds: number[], isSelectMultiple: boolean) => {
            const toBeSelectedNodes = (function () {
                if (!isSelectMultiple || !selectedNodes.length) {
                    return [...inputNodeIds];
                }

                const werentPreviouslySelected = inputNodeIds.filter(
                    (nodeId) => !selectedNodes.includes(nodeId)
                );

                if (!werentPreviouslySelected.length) {
                    return selectedNodes.filter(
                        (selectedNodeId) => !inputNodeIds.includes(selectedNodeId)
                    );
                }

                return [...selectedNodes, ...werentPreviouslySelected];
            })();

            setSelectedNodes(toBeSelectedNodes);

            return toBeSelectedNodes;
        },
        [selectedNodes]
    );

    const onNodesLoaded = usePersistNodesOnChangeViewKind({
        targetNodeIds: selectedNodes,
        setTargetNodeIds: setSelectedNodes,
        skipNext: isRevertingSelChangeEffect,
        onSkipped: () => setIsRevertingSelChangeEffect(false)
    });

    return {
        selectedNodes,
        onNodesSelected,
        setSelectedNodes,
        hoveredNodes,
        setHoveredNodes,
        hoveredEdges,
        setHoveredEdges,
        onNodesLoaded,
        setIsRevertingSelChangeEffect
    };
}
